import { ArrowBack } from '@mui/icons-material';
import { Button, Container, Stack, Typography } from '@mui/material';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { PAGES_URLS } from '../../../lib/constants/routes';

const RegistrierungVorschritt: FC<{}> = () => {
	const navigate = useNavigate();
	return (
		<>
			<Container>
				<Stack direction={'row'} justifyContent={'space-between'} sx={{ mb: '2rem' }}>
					<Typography variant="h2" component={'h1'}>
						Registrierung Ihrer Organisation
					</Typography>
					<Button variant="outlined" onClick={() => navigate(PAGES_URLS.Login)} startIcon={<ArrowBack />}>
						Zurück zur Login
					</Button>
				</Stack>

				<Typography variant="h5" component={'h2'}>
					Sie sind dabei, eine neue Organisation zu registrieren
				</Typography>
				<Typography sx={{ mt: '2rem' }}>
					Für die Registrierung Ihrer Organisation stehen Ihnen zwei Optionen zur Verfügung:
				</Typography>

				<ol>
					<li>
						<Typography sx={{ fontWeight: 600 }}>Registrierung als Organisation:</Typography>
						Wenn Ihre Organisation als kleines oder mittleres Unternehmen (KMU) eingestuft wird, klicken Sie bitte auf den
						Button „Als KMU registrieren“ und folgen Sie den weiteren Anweisungen.
					</li>
					<li>
						<Typography sx={{ fontWeight: 600 }}>Registrierung als Abteilung einer Organisation:</Typography>
						Möchten Sie eine Abteilung oder ein Tochterunternehmen registrieren, setzen Sie sich bitte direkt mit unserer
						Verwaltung in Verbindung. Unser Team wird Ihnen bei der weiteren Registrierung behilflich sein.
					</li>
				</ol>

				<Typography>
					Bitte wählen Sie eine der Optionen aus oder kontaktieren Sie uns, um die Registrierung Ihrer Abteilung zu
					besprechen.
				</Typography>

				<Stack direction={'row'} justifyContent={'space-between'} sx={{ mt: '2rem' }}>
					<Button onClick={() => navigate(PAGES_URLS.Registrierung, { state: { registrierenAls: 'KMU' } })}>
						Organisation registrieren
					</Button>
					<Button onClick={() => navigate(PAGES_URLS.Kontakt, { state: { registrierenAls: 'Abteilung' } })}>
						Abteilung registrieren
					</Button>
				</Stack>
			</Container>
		</>
	);
};

export default RegistrierungVorschritt;
